import { useState, type ReactNode } from 'react'
import { Check, Copy } from 'lucide-react'

import Button from '@/components/ui/Button'

interface Props {
  name: string
  tempPassword: string
  /** Tytuł modala — domyślnie „Hasło tymczasowe". Dla resetu można nadpisać. */
  title?: string
  /** Tekst pomocniczy nad hasłem. Zoptymalizowany pod create + reset. */
  description?: ReactNode
  onClose: () => void
}

export default function TempPasswordModal({
  name,
  tempPassword,
  title = 'Hasło tymczasowe',
  description,
  onClose,
}: Props) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(tempPassword)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // brak uprawnień / niewspierane — nic nie rób, user widzi hasło i tak
    }
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="temp-pw-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg-canvas/80 backdrop-blur-sm p-4"
    >
      <div className="rounded-card border border-border-subtle bg-bg-elevated p-6 max-w-md w-full">
        <h2 id="temp-pw-title" className="text-xl font-semibold mb-2">
          {title}
        </h2>
        <p className="text-sm text-text-muted mb-4">
          {description ?? (
            <>
              Pierwsze hasło dla <strong>{name}</strong>. Skopiuj i przekaż
              osobiście — nie wyświetlimy go ponownie. Pracownik zmieni przy
              pierwszym logowaniu.
            </>
          )}
        </p>

        <div className="rounded-card bg-brand-dark text-bg-elevated font-mono text-lg p-4 text-center select-all mb-4 break-all">
          {tempPassword}
        </div>

        <div className="flex gap-2">
          <Button
            variant="secondary"
            onClick={handleCopy}
            className="flex-1"
            type="button"
          >
            {copied ? (
              <>
                <Check className="h-4 w-4" aria-hidden /> Skopiowane
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" aria-hidden /> Kopiuj
              </>
            )}
          </Button>
          <Button onClick={onClose} className="flex-1" type="button">
            Zamknij
          </Button>
        </div>
      </div>
    </div>
  )
}
